// https://vuex.vuejs.org/en/actions.html
import NewApiService from "@/utils/new.api.service";

export default {
  
  view(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.get(`clients/${params.clientId}/scheduler`)
        .then(({data}) => {
          resolve(data.profile)
        })
        .catch((result) => {
          reject(result)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    })
  },
  update(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.put(`clients/${params.clientId}/scheduler`,params.profile)
        .then(({data}) => {
          resolve(data)
        })
        .catch((result) => {
          reject(result)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    })
  },

  create(context, params){
    context.commit("set_loading");
    return new Promise((resolve, reject) => {
      NewApiService.post("clients/"+params.clientId+"/scheduler",{type:params.profile})
        .then(({data}) => {
          resolve(data)
        })
        .catch((result) => {
          reject(result)
        })
        .finally(() => {
          context.commit("unset_loading")
        })
    })
  },
  
  credential(ctx, clientId){
    ctx.commit("set_loading");
    return new Promise(resolve => {
      NewApiService.get("clients/"+clientId+"/scheduler/send-credential")
        .then(({data}) => {
          ctx.commit("unset_loading");
          resolve(data);
        })
        .catch(({response}) => {
          ctx.commit("set_error", response.data.errors);
        })
    })
  }
};
